// Gradient definitions for metric cards and UI elements

export const gradients = {
  blue: 'linear-gradient(135deg, #2196f3 0%, #1565c0 100%)',
  orange: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
  pink: 'linear-gradient(135deg, #e91e63 0%, #c2185b 100%)',
  green: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
  purple: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)',
  cyan: 'linear-gradient(135deg, #00bcd4 0%, #0097a7 100%)',
  red: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)',
}

export const shadowColors = {
  blue: 'rgba(33, 150, 243, 0.25)',
  orange: 'rgba(255, 152, 0, 0.25)',
  pink: 'rgba(233, 30, 99, 0.25)',
  green: 'rgba(76, 175, 80, 0.25)',
  purple: 'rgba(156, 39, 176, 0.25)',
  cyan: 'rgba(0, 188, 212, 0.25)',
  red: 'rgba(244, 67, 54, 0.25)',
}

export type GradientType = keyof typeof gradients

export default gradients
